import { IPatientData } from "../../interface/IPatientData";

export interface IAppBasic {
  appName: string;
  appType:
    | "Quick Online Courses"
    | "Face to Face Discussions"
    | "Full Intro Training";
  identification: string;
  birthdate: string;
  benefit: string;
  plan: string;
  phoneNumber: string;
  medicalRecordNumber: string;
  referralSource: string;
  notes: string;
  specialConditions: string;
  agreeToTerms: boolean;
  patientName: string;
  cardNumber: string;
  birthDate: string;
  policyNumber: string;
  policyPeriod: string;
  clinic: string;
  memberData?: any;
  benefitDetail?: any;
  treatmentType?: string;
  indate?: string;
  jenisPerawatan?: 'Perawatan Auth' | 'Perawatan Non-Auth';
  tanggalRencanaPerawatan?: string;
  tanggalPerawatan?: string;
}

export type TAppFramework = "HTML5" | "ReactJS" | "Angular" | "Vue";

export interface IAppDatabase {
  databaseName: string;
  databaseSolution: "MySQL" | "Firebase" | "DynamoDB";
}

export type TAppStorage = "Print Out";

export interface ICreateAppData {
  appBasic: IAppBasic;
  appFramework: TAppFramework;
  appDatabase: IAppDatabase;
  appStorage: TAppStorage;
}

export const defaultCreateAppData: ICreateAppData = {
  appBasic: {
    appName: "",
    appType: "Quick Online Courses",
    identification: "",
    birthdate: "",
    benefit: "",
    plan: "",
    phoneNumber: "",
    medicalRecordNumber: "",
    referralSource: "",
    notes: "",
    specialConditions: "",
    agreeToTerms: false,
    patientName: "",
    cardNumber: "",
    birthDate: "",
    policyNumber: "",
    policyPeriod: "",
    clinic: "",
    treatmentType: "Rawat inap",
    indate: "",
    
  },
  appFramework: "HTML5",
  appDatabase: { databaseName: "db_name", databaseSolution: "MySQL" },
  appStorage: "Print Out",
};

export type StepProps = {
  data: ICreateAppData;
  updateData: (fieldsToUpdate: Partial<ICreateAppData>) => void;
  hasError: boolean;
  memberData?: any;
  benefitDetail?: any;
  errorMessageProduct?:any;
  errorMessageBenefit?:any;
  handlePatientDataFetchSuccess?: (fetchedPatientData: IPatientData) => void;
  handlePatientDataFetchError?: () => void;
  handleStep2ValidationSuccess?: () => void;
  handleStep2ValidationError?: () => void;
  handleStep3ValidationSuccess?: () => void;
  handleStep3ValidationError?: () => void;
  handleClaimValidationSuccess?: (isValid: boolean) => void;
  handleStep6ValidationSuccess?: () => void;
  handleStep6ValidationError?: () => void;
};
